import "./Login.css";
import { useState } from "react";
import { loginBranchRequest } from "../../api/auth.api";
import { useNavigate } from "react-router-dom";

export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();

        try {
            const res = await loginBranchRequest({ username, password });

            localStorage.setItem("access_token", res.access_token);
            localStorage.setItem("branch", JSON.stringify(res.branch));
            localStorage.setItem("branch_users", JSON.stringify(res.branch_users));

            navigate("/dashboard");
        } catch (err) {
            console.error(err);
            alert("Login error");
        }
    };


    return (
        <div className="login-page">
            <form className="login-card" onSubmit={submit}>
                <h2>Attendance Pro</h2>

                <input
                    placeholder="Username"
                    onChange={(e) => setUsername(e.target.value)}
                />

                <input
                    type="password"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button>Login</button>
            </form>
        </div>
    );
}
